import { render, staticRenderFns } from "./AddressOverview.vue?vue&type=template&id=406519a6"
import script from "./AddressOverview.vue?vue&type=script&lang=js"
export * from "./AddressOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports